import { render, staticRenderFns } from "./UpscaleRegionCard.vue?vue&type=template&id=7f5e9562&scoped=true"
import script from "./UpscaleRegionCard.vue?vue&type=script&lang=js"
export * from "./UpscaleRegionCard.vue?vue&type=script&lang=js"
import style0 from "./UpscaleRegionCard.vue?vue&type=style&index=0&id=7f5e9562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e9562",
  null
  
)

export default component.exports